import { Chip } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormCombos } from '../../../../../../hooks/useFormCombos';
import { Select } from '../../../../../Common/Select';
import { CardTitle, Container } from './styles';


interface IGroupModalitiesCardProps {
    selectedModalities: {
        id: string;
        name: string;
    }[];
    setSelectedModalities: React.Dispatch<React.SetStateAction<{
        id: string;
        name: string;
    }[]>>
}

const GroupModalitiesCard: React.FC<IGroupModalitiesCardProps> = ({ selectedModalities, setSelectedModalities }) => {
    const { t, i18n } = useTranslation();

    const {
      modalityList,
      getAllModalityByLanguageId,
    } = useFormCombos();
    
    useEffect(() => {
        getAllModalityByLanguageId(i18n.language, false);   
    }, []);

    return (
        <Container>
            <CardTitle>{t("softwareManagement.modules.groups.modalityGroups")}</CardTitle>

            <Select
                fullWidth
                id="modalities"
                style={{marginTop: '12px'}}
                options={modalityList}
                value={selectedModalities}
                label={t("softwareManagement.modules.groups.modalities")}
                setValue={(values: any) => {
                    setSelectedModalities(values);
                }}
                multiple={true}
                renderTags={(selectedValues: {id:string; name: string}[]) => {
                  return (
                    selectedValues.map((option) => (
                      <Chip
                        style={{margin: '2px'}}
                        key={option.id}
                        onDelete={() => {
                          setSelectedModalities(selectedModalities.filter(v => v.id !== option.id));
                        }}
                        onClick={() => {
                          setSelectedModalities(selectedModalities.filter(v => v.id !== option.id));
                        }}
                        variant="outlined"
                        label={option.name}
                      />
                    ))
                  )
                }}
              />
        </Container>
    );
}

export default GroupModalitiesCard;
